import { Box } from '@mantine/core';
import { useParams } from 'react-router';
import { isEmpty, isNullish } from 'remeda';
import { useLoadTemplateV2 } from 'shared/hooks/use-load-template-v2';
import { CHANNEL_CONFIGS } from './channels';
import { useActiveChannelAtom, useTemplateLanguageAtom } from './state';
import { TemplateBodyEditor } from './TemplateBodyEditor';
import { TemplateEditorEmptyState } from './TemplateEditorEmptyState';

export const TemplateEditorContent = () => {
  const { templateId } = useParams<{ templateId: string }>();
  const { template } = useLoadTemplateV2(templateId);
  const [activeChannel] = useActiveChannelAtom();
  const [language] = useTemplateLanguageAtom();

  if (isNullish(template)) return null;

  const hasNoPopulatedChannels = isEmpty(template.bodies.email) && isEmpty(template.bodies.letter);
  if (hasNoPopulatedChannels) {
    return <TemplateEditorEmptyState templateId={template.id} stepType={template.stepType} />;
  }

  const firstPopulatedChannel = CHANNEL_CONFIGS.find(
    ({ key }) => !isEmpty(template.bodies[key]),
  )?.key;
  const channel = activeChannel ?? firstPopulatedChannel;

  if (isNullish(channel) || isNullish(language)) return null;

  const activeBody = template.bodies[channel].find(({ locale }) => locale === language);

  return (
    <Box h="100%" w="100%">
      <TemplateBodyEditor
        key={`${channel}-${language}`}
        templateId={template.id}
        channel={channel}
        locale={language}
        content={activeBody?.body ?? ''}
        planType={template.planType}
      />
    </Box>
  );
};
